import type { HttpClient, Result } from '@/lib/http/HttpClient';
import type {
  FeedbackRating,
  PredictionSource,
  RecentPrediction,
} from '../type/ModelPredictionTypes';

/**
 * Client for the saved ML predictions of the analytic module (recent list and
 * thumbs, shared by the tool-wear and live-signals tabs).
 * Requires the analytic + tracabilite module keys.
 */
export class ModelPredictionApiClient {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  recentPredictions(
    source?: Exclude<PredictionSource, 'registry'>,
    signal?: AbortSignal
  ): Promise<Result<{ timestamp: string; predictions: RecentPrediction[] }>> {
    const query = source ? `?source=${source}` : '';
    return this.http.get<{ timestamp: string; predictions: RecentPrediction[] }>(
      `/api/analytic/predictions/recent${query}`,
      signal ? { signal } : undefined
    );
  }

  submitFeedback(
    predictionId: string,
    rating: FeedbackRating
  ): Promise<Result<{ timestamp: string; predictionId: string; rating: FeedbackRating }>> {
    return this.http.post<{ timestamp: string; predictionId: string; rating: FeedbackRating }>(
      '/api/analytic/predictions/feedback',
      { predictionId, rating }
    );
  }
}
